import { nutrientsFields } from "constants/nutrients";

export const getUnits = (field: string) => {
  return nutrientsFields[field]?.units ?? "";
};

export const getNutrientLabel = (field: string) => {
  return nutrientsFields[field]?.label ?? "";
};
